export const fbAppId = process.env.REACT_APP_FB_APP_ID;
export const fbSdkVersion = process.env.REACT_APP_FB_SDK_VERSION;

export const tokenNames = Object.freeze({
  ACCESS_TOKEN: 'access_token',
  REFRESH_TOKEN: 'refresh_token',
} as const);

// `/login` và `/token/refresh` dùng `platform` để chọn cấu trúc response và để chặn app quá cũ.
// CMS không bị chặn theo version nên luôn gửi 'other'.
export const apiPlatform = 'other';

export const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;
